import React from 'react';
import { message } from 'antd';
import { useViewerStore } from '@store/viewerModule/base';
import { buildInterval } from '../common/utils';
import { customerType, sessionsResponse } from '@components/viewer-module/AISummary/atom';
import { useAtomValue } from 'jotai';
import { useAnalyzeSummarize } from './useAnalyzeSummarize';
import { AISummary } from './AISummary';
import styled from 'styled-components';

const SummaryWrapper = styled.div`
  width: 100%;
  max-width: 100%;
`;

export default function VideoSummarizeContainer() {
  const [{ interval, viewerId }] = useViewerStore();
  const { isLive } = interval;

  const customerTypeValue = useAtomValue(customerType);
  const sessionsResponseValue = useAtomValue(sessionsResponse);

  const { isLoading, data, error, summarize } = useAnalyzeSummarize();

  const handleGenerate = async () => {
    if (isLive) {
      message.warning(`AI Summary doesn't support live mode`, 10);
      return;
    }

    const diagnosticPayload = {
      type: 'user-timeline-summary',
      customerType: customerTypeValue,
      sessionsResponse: sessionsResponseValue,
      interval: buildInterval(interval),
      viewerId: viewerId,
    };

    await summarize(diagnosticPayload);
  };

  const handleRegenerate = async () => {
    const diagnosticPayload = {
      type: 'user-timeline-summary',
      customerType: customerTypeValue,
      sessionsResponse: sessionsResponseValue,
      interval: buildInterval(interval),
      viewerId: viewerId,
    };

    await summarize(diagnosticPayload);
  };

  if (!viewerId) {
    return null;
  }

  return (
    <SummaryWrapper>
      <AISummary
        isLoading={isLoading}
        data={data}
        error={error}
        onGenerate={handleGenerate}
        onRegenerate={handleRegenerate}
        disabled={isLive}
      />
    </SummaryWrapper>
  );
}
